import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiRoutes } from 'src/app/config/api-routes';
import { environment } from 'src/environments/environment';
import { AuthenticationResponse } from '../model/authenticationResponse';

@Injectable()
export class AuthenticationService {

  readonly TOKEN_TAG: string = 'jwt_' + environment.environmentName;
  readonly REFRESH_TOKEN_TAG: string = 'jwt_refresh_token_' + environment.environmentName;

  constructor(private httpClient: HttpClient, private config: ApiRoutes) {
  }

  public doLoginAndAgreeLicense(): Observable<AuthenticationResponse> {
    return this.httpClient.post<AuthenticationResponse>(this.config.LOGIN_AND_AGREE_LICENSE, null);
  }
}
